import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 56px;
    
    @media (max-width: 700px) {
        gap: 15px;
    }
`;

export const ContentTable = styled.table`
    width: 100%;
    border-collapse: collapse;

    thead {
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        top: 0;
        z-index: 1;
    }

    
    th:last-child,
    td:last-child {
        width: 85px;
    }
    
    th:nth-child(1),
    td:nth-child(1){
        width: 40px;

    }

    tbody {
        display: block;
        max-height: 500px;
        overflow-y: auto;
        width: 100%;
    }

    tbody::-webkit-scrollbar { 
        display: none;
    }

    tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    }

    td,
    th {
        text-align: center;
        padding: 10px 0;
    }

    td > div {
        display: flex;
        justify-content: center;
        gap: 10px;
    }
    
    & svg {
        font-size: 18px;
    }

    @media (max-width: 900px) {
        th:nth-child(5), 
        td:nth-child(5) {
            display: none;
        }

        th:nth-child(1),
        td:nth-child(1),
        th:last-child,
        td:last-child {
            width: 50px;
        }

        tbody {
            max-height: 450px;
        }
    }
`;

export const ContentPopMenu = styled.div`
`;

export const ButtonTable = styled.button`
    display: flex;
    justify-content: center;

    padding: 8px;
    
    border-radius: 30px;
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    background-color: ${(props) => props.theme.colors.white};
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const TypeUser = styled.p`
    background-color: ${(props) => props.theme.colors.red.red_50};
    color: ${(props) => props.theme.colors.primary};
    border-radius: 4px;
    padding: 3px 5px;
`;

export const UserProfile = styled.div`
    display: flex;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.gray.gray_800};
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0px 4px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    font-weight: 600;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`;